import { ConvexReactClient } from "convex/react";

const convexUrl = import.meta.env.VITE_CONVEX_URL;

if (!convexUrl) {
  // eslint-disable-next-line no-console
  console.warn("VITE_CONVEX_URL is not set. Convex features will be disabled.");
}

const convex = new ConvexReactClient(convexUrl || "");

export default convex;
